import { render, staticRenderFns } from "./SourcePage.vue?vue&type=template&id=198fa80a"
import script from "./SourcePage.vue?vue&type=script&lang=js"
export * from "./SourcePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports